import React from "react";

export default function Text({
  content,
  isSingleStepScreen,
  singleScreenStep,
  id,
}) {
  console.log(singleScreenStep);
  return (
    <div
      style={{
        margin: content.component_margin
          ? content.component_margin
          : window.navigator.platform.includes("Win")
          ? content.windows_margin
          : "0",
      }}
    >
      {content.content.map((item, i) => {
        return (
          <p
            key={`text${i}`}
            className={
              item.type === "title"
                ? "body-title"
                : id === "single"
                ? "single-text body-text"
                : "body-text"
            }
            style={{
              fontFamily: item.font ? item.font : "LG_Smart_Regular",
              fontSize: item.font_size,
              color: item.font_color,
              margin: item.margin ? item.margin : "0px",
              width: item.width ? item.width : "auto",
              lineHeight: item.line_height ? item.line_height : null,
              animation:
                item.svg === "mr-ov" ? "0.5s fadeIn 0.3s forwards" : "none",
              opacity: item.svg === "mr-ov" ? 0 : 1,
            }}
            dangerouslySetInnerHTML={{
              __html: isSingleStepScreen
                ? item.text[singleScreenStep]
                : item.text,
            }}
          ></p>
        );
      })}
    </div>
  );
}
